import { useState } from 'react';
import { cn } from '../../lib/utils';
import { Sidebar } from './Sidebar';

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-body">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      <div className={cn('transition-all duration-300', sidebarCollapsed ? 'ml-16' : 'ml-64')}>
        <main className="p-6">{children}</main>
      </div>
    </div>
  );
};

export default AppLayout;
